<template>
  <div>
    <blockquote
      v-if="!nodos.length"
      class="quote quote-maps-primary quote-first"
    >
      <p>
        <span>
          {{ $t('mEditionMapActivation.quote.firstText') }}
          {{ $t('mEditionMapActivation.quote.secondText') }}
          <router-link
            :to="`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.path.subject')}`"
            class="text-color-maps-primary"
          >
            {{ $t('mEditionMenu.map.path.text') }}.
          </router-link>
        </span>
      </p>
    </blockquote>

    <MoleculeEditionMapActivationImmediate
      v-if="!element.fecha_inicio && nodos.length"
      key="activationInmediate"
      :element="element"
    />
    <MoleculeEditionMapActivationDate
      v-else-if="element.fecha_inicio && nodos.length"
      key="activationDate"
      :element="element"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapActivationDays',

  components: {
    MoleculeEditionMapActivationDate: () => import('@/components/molecules/MoleculeEditionMapActivationDate'),
    MoleculeEditionMapActivationImmediate: () => import('@/components/molecules/MoleculeEditionMapActivationImmediate')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  computed: {
    nodos () {
      return [...this.$store.getters.getAssetNodes]
    }
  }
}
</script>
